<template>

    <v-section col="col-md-10">
        <h3 class="mb-30">Clear and simple pricing. All features. No surprises.</h3>
        <p>Compare the monthly price for 1,000 users<i class="fas fa-level-down-alt ml-10"></i></p>
        <div class="plans">
            <div class="plan">
                <div class="plan-header">{{ company }}</div>
                <div class="plan-body">
                    <div class="price"><span class="num">{{ price }}</span> / mo.</div>
                    <div class="desc">{{ desc }}</div>
                </div>
            </div>
            <div class="plan cp">
                <div class="plan-header">CrowdPower</div>
                <div class="plan-body">
                    <div class="price mb-10 text-primary"><span class="num">$70</span> / mo.</div>
                    <div class="desc">With CrowdPower, you get every feature with no limits on automations, email sends, number of projects, and number of team members. Our pricing is solely based on the number of customers you have. We grow when you grow.</div>
                </div>
            </div>
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    .plans {
        display: grid;
        gap: 15px;
        grid-template-columns: repeat(2, 1fr);
        @media (max-width: map-get($grid-breakpoints, 'md')) {
            grid-template-columns: 1fr;
        }
    }

    .plan {
        border: 1px solid $color-rule;
        border-radius: 5px;
        .plan-header {
            @include font-semibold(16px);
            background: $color-bg;
            padding: 10px 0;
            text-align: center;
        }
        .plan-body {
            padding: 30px;
            .price {
                @include font-semibold(16px);
                .num {
                    font-size: 30px;
                }
            }
            .desc {
                @include font-medium(15px);
                line-height: 1.6em;
            }
        }
        &.cp {
            border-color: $color-primary;
            .plan-header {
                background: $color-primary;
                color: #fff;
            }
        }
    }

</style>

<script>

export default {

    computed: {

        slug() {
            return this.$route.name.split('-')[1].toLowerCase();
        },

        company() {
            switch (this.slug) {
            case 'activecampaign':
                return 'ActiveCampaign';
            case 'customerio':
                return 'Customer.io';
            case 'hubspot':
                return 'HubSpot';
            case 'intercom':
                return 'Intercom Engage';
            default:
                return '';
            }
        },

        price() {
            switch (this.slug) {
            case 'activecampaign':
                return '$149';
            case 'customerio':
                return '$150';
            case 'hubspot':
                return '$890';
            case 'intercom':
                return 'Hundreds';
            default:
                return '';
            }
        },

        desc() {
            switch (this.slug) {
            case 'activecampaign':
                return 'ActiveCampaign is a product built for Ecommerce brands and sales teams. The product is packed with a wide range of features and bloat, with various pricing plans. The setup is tedious, and the automations may be difficult to create if you’re new to marketing automation.';
            case 'customerio':
                return 'Customer.io has a base fee of $150 per month to access their customer data platform with marketing automations. The automations can be complicated workflows with if/else branching and may be difficult to set up if marketing automation is new to you.';
            case 'hubspot':
                return 'HubSpot is a suite of products meant for sales teams at mid-level B2B companies. They get you hooked with low prices and promotions, but you’ll quickly find out if you want to make the most of it, you’ll end up paying hundreds of dollars per month to achieve the same things we offer.';
            case 'intercom':
                return 'Intercom has changed their pricing structure so much over the years, we lost track. Their pricing is no longer listed because of their focus on enterprise businesses. They get you hooked with their chat service, but if you want to engage with your customers, it will cost you hundreds of dollars per month.';
            default:
                return '';
            }
        },

    }

}

</script>